import React from 'react';
import { StatCard } from './StatCard';
import { ErrorBanner } from './DashboardShared';
import { SkeletonCard } from '../ui/SkeletonBlock';

export function PageSummaryStats({
  stats,
  isFirstLoad,
  error,
  emptyMessage = 'No data found for this period. Try adjusting your filters.',
  skeletonCount = 4,
}) {
  return (
    <div className="grid min-w-0 gap-4 md:grid-cols-2 xl:grid-cols-4">
      {isFirstLoad ? (
        <>
          <SkeletonCard featured />
          {Array.from({ length: skeletonCount - 1 }, (_, index) => (
            <SkeletonCard key={index} />
          ))}
        </>
      ) : error ? (
        <ErrorBanner message={error} />
      ) : stats.length === 0 ? (
        <div className="col-span-full rounded-xl border border-slate-200/90 bg-white px-4 py-6 text-center text-sm text-slate-400 shadow-[0_4px_16px_rgba(15,23,42,0.08)]">
          {emptyMessage}
        </div>
      ) : (
        stats.map((stat) => (
          <StatCard
            key={stat.title}
            {...stat}
          />
        ))
      )}
    </div>
  );
}
